App.filter('capitalizeFilter', function() {
    return function(input, replaceUnderscores) {
        replaceUnderscores = replaceUnderscores || false;

        if (replaceUnderscores) {
            input = input.replace(/_/g, ' ');
        }

        return input.charAt(0).toUpperCase() + input.slice(1);
    }
});